import { useEffect, useRef } from 'react';

// 모바일/브라우저 '뒤로가기'로 오버레이(라이트박스·모달)를 닫기 위한 훅.
//
// 문제: 라이트박스를 React state로만 열면 history 엔트리가 없어, 모바일에서
// 닫으려고 뒤로가기를 누르면 오버레이 대신 SPA 자체가 이탈한다(홈이 첫 진입
// 페이지면 사이트 종료).
//
// 해결: 오버레이가 열릴 때 더미 history 엔트리를 push → 뒤로가기가 그 엔트리를
// pop하며 popstate를 발생 → 그때 onClose를 호출해 오버레이만 닫는다.
// 사용자가 X/ESC 등으로 직접 닫으면(isOpen=false) cleanup에서 history.back()으로
// 우리가 push한 엔트리를 정리한다(뒤로가기로 닫힌 경우엔 이미 pop돼 중복 호출 안 함).
//
// isOpen: 오버레이 열림 여부 (예: !!lightbox, openIndex >= 0)
// onClose: 닫기 콜백 (state 리셋)
export default function useBackButtonClose(isOpen, onClose) {
  // 최신 onClose를 참조 — onClose 신원이 매 렌더 바뀌어도 effect 재실행 방지.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  // 우리가 push한 history 엔트리가 아직 살아있는지 추적.
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    // open: 더미 엔트리 push. 뒤로가기가 이 엔트리를 pop하면 popstate 발생.
    window.history.pushState({ overlay: true }, '');
    pushedRef.current = true;

    const onPop = () => {
      // 뒤로가기로 우리 엔트리가 사라짐 → 닫기만 수행(추가 back 불필요).
      pushedRef.current = false;
      onCloseRef.current();
    };
    window.addEventListener('popstate', onPop);

    return () => {
      window.removeEventListener('popstate', onPop);
      // 사용자가 직접 닫아(isOpen=false) cleanup이 돌고, 엔트리가 아직 살아있으면
      // history.back()으로 정리. 이때 popstate가 발생하지만 리스너는 이미 제거됨.
      if (pushedRef.current) {
        pushedRef.current = false;
        window.history.back();
      }
    };
  }, [isOpen]);
}
